<app-fiche-descriptive *ngIf="(standaloneMode | async) === 'fiche-descriptive'"></app-fiche-descriptive>

<app-fiche-commentaire *ngIf="(standaloneMode | async) === 'commentaire'"></app-fiche-commentaire>

<app-gdf-impression-bail *ngIf="(standaloneMode | async) === 'gdf-impression-bail'"></app-gdf-impression-bail>

<ng-container *ngIf="(standaloneMode | async) === ''">
  <igo-spinner igoSpinnerActivity></igo-spinner>
  <app-portal [ngClass]="
      hasHeader
        ? hasFooter
          ? 'portal-with-header-footer'
          : 'portal-with-header'
        : hasFooter
        ? 'portal-with-footer'
        : 'portal'
    "
    igoStopDropPropagation
  ></app-portal>
</ng-container>


